import React, { useState, useEffect, useRef } from "react";
import {
  MegaMenuDiv,
  MobileNavMenu,
  NavArrow,
  NavDiamondImg,
  NavDiv,
  NavDivTwo,
  NavInnerDiv,
  NavLogoImg,
  NavSmallArrow,
  NavText,
  Search,
  UpgradeDiv,
  UpgradeDivBoldText,
  UpgradeDivSimpleText,
  UpgradeOuterDiv,
  UserLogo,
} from "./style";
import SwiftLogo from "../../assets/images/navlogo.svg";
import NavArrowImg from "../../assets/images/navarrow.svg";
import NavSArrow from "../../assets/images/navsmallarrow.svg";
import SearchImg from "../../assets/images/navsearch.svg";
import { Btn, FlexDiv } from "../../assets/styles/style";
import DiamondImg from "../../assets/images/navdiamond.svg";
import UserAvatar from "../../assets/images/user-avatar.png";
import MobileMenu from "../../assets/images/mobilemenu.svg";
import {
  Alert,
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Popover,
  Typography,
  useMediaQuery,
} from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import MoreMenu from "./MoreMenu";
import MegaMenu from "./MegaMenu";
import MobileNav from "./MobileNav";
import Collapse from "@mui/material/Collapse";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileDropDown from "./ProfileDropDown";
import PteToggleBtn from "./PteToggleBtn";
import ExamTypeToggle from "./ExamTypeToggle";
import IeltsToggle from "./IeltsToggle";
import IeltsNavTabs from "./IeltsNavTabs";
import { Base_URL } from "../../Client/apiURL";
import { useTestQuestions } from "../../context/TestQuestionContext";
import { useStoredUserData } from "../../authentication/userSession";

function getOneOnOneCreditStorageKey() {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userId = userData?.UserId || "guest";
  return `ielts-1on1-credit-used-${userId}`;
}

const Navbar = () => {
  const isLaptop = useMediaQuery("(max-width:1000px)");
  const [moreMenu, setMoreMenu] = useState(false);
  const [megaMenu, setMegaMenu] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [urlColor, setUrlColor] = useState([false, false, false, false]);
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  const [storedUserImage, setStoredUserImage] = useState(null);
  const [selectedText, setSelectedText] = useState(true);
  const [active, setActive] = useState(0);
  const [showVIP, setShowVIP] = useState(false);
  const [remianingDays, setRemianingDays] = useState(null);
  const userData = useStoredUserData() || {};
  const portalData = JSON.parse(localStorage.getItem("portalData")) || {};
  const hasPortalLogo = Boolean(portalData.portal_logo);
  const [subDays, setSubDays] = useState(0);
  const { resetAllStates } = useTestQuestions();
  const [examType, setExamType] = useState("pte");
  const location = useLocation();
  const [showBookClassModal, setShowBookClassModal] = useState(false);
  const [isOneOnOneCreditUsed, setIsOneOnOneCreditUsed] = useState(false);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const [teacherNotifications, setTeacherNotifications] = useState([]);
  const [teacherAccessRequests, setTeacherAccessRequests] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const isIeltsDashboardPage = location.pathname === "/ielts-dashboard";
  const isSubscribed = !!userData?.IsSubscribed;
  const shouldShowOneOnOneBooking = isIeltsDashboardPage && isSubscribed;
  const unreadTeacherNotifications = teacherNotifications.filter((item) => !item.isRead).length;
  const pendingTeacherAccessRequestItems = teacherAccessRequests.filter((item) => item.status === "pending");
  const pendingTeacherAccessRequests = pendingTeacherAccessRequestItems.length;
  const hasResultAccess = teacherAccessRequests.some((item) => item.status === "pending" || item.status === "approved");
  const canFetchTeacherNotifications = !!userData?.UserId && new URLSearchParams(window.location.search).get("user") !== "instructor";

  useEffect(() => {
    const item = localStorage.getItem("pte-type");
    if (item === "pte academic") {
      setSelectedText(true); 
      setActive(0);
    } else {
      setSelectedText(false);
      setActive(1);
    }
  }, []);

  useEffect(() => {
    if (!shouldShowOneOnOneBooking) return;
    setIsOneOnOneCreditUsed(localStorage.getItem(getOneOnOneCreditStorageKey()) === "1");
  }, [shouldShowOneOnOneBooking]);

  useEffect(() => {
    const storedUserDataString = localStorage.getItem("userData");
    if (storedUserDataString) {
      const storedUserData = JSON.parse(storedUserDataString);
      if (storedUserData && storedUserData.UserName) {
        setUserName(storedUserData.UserName);
        setStoredUserImage(storedUserData.ImageUrl);
      }
      if(storedUserData.IsSubscribed){
        setShowVIP(false);
      }else{
        setShowVIP(true);
      }
      
      const givenDateString = storedUserData.SubscriptionEndTimeUTC;
      if (givenDateString) {
        const givenDate = new Date(givenDateString);
        const currentDate = new Date();
        const timeDifference = givenDate - currentDate;
        const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        setRemianingDays(dayDifference);
      } else {
        setRemianingDays(0);
      }
      
    }
  }, []);

  useEffect(() => {
    const handleUserDataChange = () => {
      const storedUserDataString = localStorage.getItem("userData");
      if (storedUserDataString) {
        const storedUserData = JSON.parse(storedUserDataString);
        if (storedUserData && storedUserData.UserName) {
          setUserName(storedUserData.UserName);
          setStoredUserImage(storedUserData.ImageUrl);
        }
        if (storedUserData.IsSubscribed) {
          setShowVIP(false);
        } else {
          setShowVIP(true);
        }

        const givenDateString = storedUserData.SubscriptionEndTimeUTC;
        if (givenDateString) {
          const givenDate = new Date(givenDateString);
          const currentDate = new Date();
          const timeDifference = givenDate - currentDate;
          const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
          setRemianingDays(dayDifference);
        } else {
          setRemianingDays(null);
        }

      }
    };

    window.addEventListener('userDataChanged', handleUserDataChange);

    return () => {
      window.removeEventListener('userDataChanged', handleUserDataChange);
    };
  }, []);

  const fetchSubscriptions = async () => {
    try {
      const response = await fetch(
        `${Base_URL}/app/users/subscriptions/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );

      const data = await response.json();
      if (data.responseCode === 200) {
        data.response.map((item) => {
          if(item.Id ===  userData.SubscriptionID){
            const givenDateString = userData.SubscriptionEndTimeUTC;
            const givenDate = new Date(givenDateString);
            const currentDate = new Date();
            const timeDifference = givenDate - currentDate;
            const dayDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            setSubDays(item.Days);
            if(item.Days > 0 && item.Days){
              setRemianingDays(dayDifference);
            }
          }
        });
      }
    } catch (error) {
      console.error("Failed to fetch subscriptions:", error);
    }
  };

  useEffect(() => {
    // Check if we're in instructor/admin mode - skip subscriptions API call
    const urlParams = new URLSearchParams(window.location.search);
    const isAdminMode = urlParams.get('user') === 'instructor';
    
    if (!isAdminMode) {
      fetchSubscriptions();
    }
  }, []);  

  const open = Boolean(anchorEl);
  const notificationsOpen = Boolean(notificationAnchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateTo = (url) => {
    resetAllStates();
    navigate(url)
  }

  const fetchTeacherNotifications = async () => {
    if (!canFetchTeacherNotifications) return;

    try {
      setNotificationsLoading(true);
      const [reviewResponse, accessResponse] = await Promise.all([
        fetch(`${Base_URL}/app/users/ielts-tests/teacher-review-notifications`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }),
        fetch(`${Base_URL}/app/users/teacher-access/requests`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }),
      ]);
      const reviewData = await reviewResponse.json();
      const accessData = await accessResponse.json();
      if (reviewData.responseCode === 200 && Array.isArray(reviewData.response)) {
        setTeacherNotifications(reviewData.response);
      }
      if (accessData.responseCode === 200 && Array.isArray(accessData.response)) {
        setTeacherAccessRequests(accessData.response);
      }
    } catch (error) {
      console.error("Failed to fetch IELTS teacher notifications:", error);
    } finally {
      setNotificationsLoading(false);
    }
  };

  const handleTeacherNotificationClick = async (notification) => {
    setNotificationAnchorEl(null);
    if (notification?.id) {
      setTeacherNotifications((items) =>
        items.map((item) => item.id === notification.id ? { ...item, isRead: true } : item)
      );
      fetch(`${Base_URL}/app/users/ielts-tests/teacher-review-notifications/${notification.id}/read`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }).catch((error) => console.error("Failed to mark IELTS teacher notification as read:", error));
    }
    if (notification?.targetUrl) {
      navigate(notification.targetUrl);
    }
  };

  const clearReadTeacherNotifications = async () => {
    try {
      const response = await fetch(`${Base_URL}/app/users/ielts-tests/teacher-review-notifications/clear-read`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      const data = await response.json();
      if (data.responseCode === 200) {
        setTeacherNotifications((items) => items.filter((item) => !item.isRead));
      }
    } catch (error) {
      console.error("Failed to clear read IELTS teacher notifications:", error);
    }
  };

  const handleConfirmBookOneOnOne = () => {
    localStorage.setItem(getOneOnOneCreditStorageKey(), "1");
    setIsOneOnOneCreditUsed(true);
    setShowBookClassModal(false);
    window.open("https://calendly.com/swiftuni/swiftuni-1-on-1", "_blank", "noopener,noreferrer");
  };

  const renderOneOnOneBookingButton = () => {
    if (!shouldShowOneOnOneBooking) return null;

    return (
      <Button
        variant="contained"
        disabled={isOneOnOneCreditUsed}
        onClick={() => setShowBookClassModal(true)}
        sx={{
          textTransform: "none",
          fontWeight: 900,
          borderRadius: "999px",
          px: { xs: 1.3, md: 2.1 },
          py: { xs: 0.65, md: 0.85 },
          minWidth: { xs: "auto", md: "128px" },
          fontSize: { xs: "0.78rem", md: "0.9rem" },
          whiteSpace: "nowrap",
          background: isOneOnOneCreditUsed
            ? "#b8b8c6"
            : "linear-gradient(135deg, #00a86b 0%, #0d8f76 100%)",
          boxShadow: isOneOnOneCreditUsed
            ? "none"
            : "0 10px 20px rgba(13, 143, 118, 0.24)",
          "&:hover": {
            background: isOneOnOneCreditUsed
              ? "#b8b8c6"
              : "linear-gradient(135deg, #008f5b 0%, #087765 100%)",
          },
        }}
      >
        {isOneOnOneCreditUsed ? "Class Used" : "Book 1-on-1"}
      </Button>
    );
  };

  useEffect(() => {
    const currentURL = window.location.pathname;
    const homePath = "/";
    const practicePaths = ["/reading", "/writing", "/speaking", "/listening"];
    const mockTestPath = "/MockTest";
    const morePaths = [
      "/templates",
      "/grammar",
      "/vocab-bank",
      "/score-feedback",
      "/strategy-videos",
      "mt-score",
      "/ai-study-plan",
      // "/pte-guide",
      "https://swiftuni.com/pte-guide/",
    ];

    let newColors = [false, false, false, false];

    if (currentURL === homePath) {
      newColors[0] = true;
    } else if (practicePaths.some((path) => currentURL.includes(path))) {
      newColors[1] = true;
    } else if (currentURL.includes(mockTestPath)) {
      newColors[2] = true;
    } else if (morePaths.some((path) => currentURL.includes(path))) {
      newColors[3] = true;
    }

    setUrlColor(newColors);
  }, [window.location.pathname]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const navInnerDiv = document.getElementById("nav-inner-div");
      const moreMenu = document.getElementById("more-menu");
      const megaMenu = document.getElementById("mega-menu");

      if (navInnerDiv && navInnerDiv.contains(event.target)) {
        return;
      }
      if (moreMenu && moreMenu.contains(event.target)) {
        return;
      }
      if (megaMenu && megaMenu.contains(event.target)) {
        return;
      }

      setMoreMenu(false);
      setMegaMenu(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const normalizeImageURL = (url) => {
    if (!url) return null;

    // Fix SVG URLs with '+xml'
    if (url.endsWith(".svg+xml")) {
      return url.replace(".svg+xml", ".svg");
    }

    return url; // Return other URLs unchanged
  };

  useEffect(() => {
    // Check the exam type
    const storedExamType = localStorage.getItem("exam-type");
    if (storedExamType) {
      setExamType(storedExamType);
    }
    
    // Listen for exam type changes
    const handleExamTypeChange = (event) => {
      setExamType(event.detail.examType);
    };
    
    window.addEventListener("examTypeChanged", handleExamTypeChange);
    
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("examTypeChanged", handleExamTypeChange);
    };
  }, []);

  useEffect(() => {
    if (!canFetchTeacherNotifications) return;

    fetchTeacherNotifications();
  }, [canFetchTeacherNotifications]);

  useEffect(() => {
    if (!canFetchTeacherNotifications) return undefined;

    const handleTeacherAccessChanged = () => {
      fetchTeacherNotifications();
    };

    window.addEventListener("teacherAccessRequestsChanged", handleTeacherAccessChanged);
    return () => {
      window.removeEventListener("teacherAccessRequestsChanged", handleTeacherAccessChanged);
    };
  }, [canFetchTeacherNotifications]);

  useEffect(() => {
    if (!canFetchTeacherNotifications) return;

    const pollNotifications = () => {
      if (document.visibilityState === "visible") {
        fetchTeacherNotifications();
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        fetchTeacherNotifications();
      }
    };

    const intervalId = window.setInterval(pollNotifications, 60000);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [canFetchTeacherNotifications]);

  const renderTeacherNotifications = () => (
    <>
      <IconButton
        size="small"
        onClick={(event) => {
          setNotificationAnchorEl(event.currentTarget);
          fetchTeacherNotifications();
        }}
        sx={{ color: "#6B41CB" }}
        aria-label="IELTS teacher review notifications"
      >
        <Badge badgeContent={unreadTeacherNotifications + pendingTeacherAccessRequests} color="error" max={9}>
          <NotificationsNoneIcon />
        </Badge>
      </IconButton>
      <Popover
        open={notificationsOpen}
        anchorEl={notificationAnchorEl}
        onClose={() => setNotificationAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            width: 340,
            maxWidth: "calc(100vw - 24px)",
            borderRadius: "12px",
            boxShadow: "0 12px 32px rgba(35, 25, 66, 0.16)",
          },
        }}
      >
        <div style={{ padding: "12px 14px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
          <Typography sx={{ fontWeight: 800, color: "#2D2740" }}>Updates</Typography>
          <Button
            size="small"
            onClick={clearReadTeacherNotifications}
            disabled={!teacherNotifications.some((item) => item.isRead)}
            sx={{ textTransform: "none", fontWeight: 700 }}
          >
            Clear read
          </Button>
        </div>
        <List dense disablePadding sx={{ maxHeight: 360, overflowY: "auto" }}>
          {notificationsLoading && teacherNotifications.length === 0 && (
            <Typography sx={{ px: 2, py: 2, color: "#6B6478" }}>Loading...</Typography>
          )}
          {!notificationsLoading && teacherNotifications.length === 0 && pendingTeacherAccessRequestItems.length === 0 && (
            <Typography sx={{ px: 2, py: 2, color: "#6B6478" }}>No updates yet.</Typography>
          )}
          {pendingTeacherAccessRequestItems.map((request) => (
            <ListItemButton
              key={`teacher-access-${request.id}`}
              onClick={() => {
                setNotificationAnchorEl(null);
                navigate("/result-access");
              }}
              sx={{
                alignItems: "flex-start",
                gap: 1,
                borderTop: "1px solid #F0ECFA",
                backgroundColor: request.status === "pending" ? "#F7F1FF" : "#FFFFFF",
                "&:hover": { backgroundColor: "#F1E9FF" },
              }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: request.status === "pending" ? "#6B41CB" : "transparent",
                  marginTop: 10,
                  flex: "0 0 auto",
                }}
              />
              <ListItemText
                primary="Result access request"
                secondary={`${request.teacherName || "A teacher"} wants to view your results`}
                primaryTypographyProps={{ fontWeight: request.status === "pending" ? 800 : 600, color: "#2D2740", fontSize: "0.92rem" }}
                secondaryTypographyProps={{ color: "#6B6478", fontSize: "0.82rem" }}
              />
            </ListItemButton>
          ))}
          {teacherNotifications.map((notification) => (
            <ListItemButton
              key={notification.id}
              onClick={() => handleTeacherNotificationClick(notification)}
              sx={{
                alignItems: "flex-start",
                gap: 1,
                borderTop: "1px solid #F0ECFA",
                backgroundColor: notification.isRead ? "#FFFFFF" : "#F7F1FF",
                "&:hover": { backgroundColor: "#F1E9FF" },
              }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: notification.isRead ? "transparent" : "#6B41CB",
                  marginTop: 10,
                  flex: "0 0 auto",
                }}
              />
              <ListItemText
                primary={`${notification.sectionLabel || "IELTS"} reviewed by teacher`}
                secondary={`${notification.testName || "IELTS test"}${notification.teacherScore !== null && notification.teacherScore !== undefined ? ` • Score ${notification.teacherScore}` : ""}${notification.hasRemarks ? " • Remarks added" : ""}`}
                primaryTypographyProps={{ fontWeight: notification.isRead ? 600 : 800, color: "#2D2740", fontSize: "0.92rem" }}
                secondaryTypographyProps={{ color: "#6B6478", fontSize: "0.82rem" }}
              />
            </ListItemButton>
          ))}
        </List>
      </Popover>
    </>
  );

  return (
    <>
      <NavDiv id="navbar">
        <NavDivTwo>
          {isLaptop && 

          <NavLogoImg alt="Logo" 
          $isPortalLogo={hasPortalLogo}
          src={portalData && portalData.portal_logo ? normalizeImageURL(portalData.portal_logo) : SwiftLogo}
          onClick={() => navigate("/")}
          />

          }
          {!isLaptop && (
            <>
              <NavInnerDiv id="nav-inner-div">
                {!isLaptop && <NavLogoImg alt="Logo" 
                  $isPortalLogo={hasPortalLogo}
                  src={portalData && portalData.portal_logo ? normalizeImageURL(portalData.portal_logo)  : SwiftLogo}
                onClick={() => navigate("/")} />}
                
                {examType !== "ielts" ? (
                // PTE Navigation Tabs
                <>
                <Btn onClick={() => navigateTo("/")}>
                  <NavText style={{ color: urlColor[0] ? "#6B41CB" : "" }}>
                    Home
                  </NavText>
                </Btn>
                <Btn
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setMoreMenu(false);
                    setMegaMenu(!megaMenu);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "9px",
                    }}
                  >
                    <NavText style={{ color: urlColor[1] ? "#6B41CB" : "" }}>
                      Practice
                    </NavText>
                    <NavSmallArrow
                      alt=""
                      src={NavSArrow}
                      style={{ transform: megaMenu && "rotate(180deg)" }}
                    />
                  </div>
                </Btn>
                <Btn
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setMoreMenu(false);
                    setMegaMenu(false);
                    navigateTo("/MockTest");
                  }}
                >
                  <NavText
                    style={{
                      color: urlColor[2] ? "#6B41CB" : "",
                      width: "7rem",
                    }}
                  >
                    Mock Tests
                  </NavText>
                </Btn>
                <Btn
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setMegaMenu(false);
                    setMoreMenu(!moreMenu);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "9px",
                    }}
                  >
                    <NavText style={{ color: urlColor[3] ? "#6B41CB" : "" }}>
                      More
                    </NavText>
                    <NavSmallArrow
                      alt=""
                      src={NavSArrow}
                      style={{ transform: moreMenu && "rotate(180deg)" }}
                    />
                  </div>
                </Btn>
                </>
                ) : (
                  // IELTS Navigation Tabs
                  <IeltsNavTabs />
                )}
                
                {/* Search icon temporarily removed as per request
                <Search alt="" src={SearchImg} onClick={() => navigateTo("/search")} />
                */}
              </NavInnerDiv>
              <UpgradeOuterDiv>
                {showVIP? (
                <UpgradeDiv data-tour="ielts-header-subscription" onClick={()=> {
                  navigate("/sidebar", { state: { section:'Plan Info'} });
                }}>
                  <NavDiamondImg alt="" src={DiamondImg} />
                  <UpgradeDivBoldText>Upgrade</UpgradeDivBoldText>
                  <UpgradeDivSimpleText>VIP</UpgradeDivSimpleText>
                </UpgradeDiv>):
                (
                  <UpgradeDiv data-tour="ielts-header-subscription" onClick={()=> {
                    navigate("/sidebar", { state: { section:'Plan Info'} });
                  }}>

                    {remianingDays !== null && (
                      <UpgradeDivBoldText>{remianingDays}</UpgradeDivBoldText>
                    )}
                    <UpgradeDivSimpleText>Days left</UpgradeDivSimpleText>
                  </UpgradeDiv>)                
                }
                {renderOneOnOneBookingButton()}
                <FlexDiv data-tour="ielts-header-controls" style={{ gap: "10px" }}>
                  {renderTeacherNotifications()}
                  {examType !== "ielts" && (
                  <FlexDiv>
                    <PteToggleBtn active={active} setActive={setActive} />
                  </FlexDiv>
                  )}
                  {examType === "ielts" && (
                    <FlexDiv>
                      <IeltsToggle />
                    </FlexDiv>
                  )}
                  <FlexDiv style={{ marginLeft: examType !== "ielts" ? "10px" : "0px" }}>
                    <ExamTypeToggle />
                  </FlexDiv>
                  <FlexDiv style={{ cursor: "pointer" }} onClick={handleClick}>
                    <UserLogo alt="" src={storedUserImage || UserAvatar} />
                    <NavArrow
                      alt=""
                      src={NavArrowImg}
                      style={{
                        transform: open && "rotate(180deg)",
                      }}
                    />
                  </FlexDiv>
                </FlexDiv>
                <ProfileDropDown
                  anchorEl={anchorEl}
                  open={open}
                  handleClose={handleClose}
                  userImage={storedUserImage || UserAvatar}
                  userName={userName}
                  showResultAccess={hasResultAccess}
                />
              </UpgradeOuterDiv>
            </>
          )}
          {isLaptop && (
            <>
              <UpgradeOuterDiv>
              {showVIP? (
                <UpgradeDiv data-tour="ielts-header-subscription" onClick={()=> {
                  navigate("/sidebar", { state: { section:'Plan Info'} });
                }}>
                  <NavDiamondImg alt="" src={DiamondImg} />
                  <UpgradeDivBoldText>Upgrade</UpgradeDivBoldText>
                  <UpgradeDivSimpleText>VIP</UpgradeDivSimpleText>
                </UpgradeDiv>):
                (
                  <UpgradeDiv data-tour="ielts-header-subscription" onClick={()=> {
                    navigate("/sidebar", { state: { section:'Plan Info'} });
                  }}>
                    {remianingDays !== null && (
                      <UpgradeDivBoldText>{remianingDays}</UpgradeDivBoldText>
                    )}
                    <UpgradeDivSimpleText>Days left</UpgradeDivSimpleText>
                  </UpgradeDiv>)                
                }
                {renderOneOnOneBookingButton()}
                <FlexDiv data-tour="ielts-header-controls" style={{ gap: "10px" }}>
                  {renderTeacherNotifications()}
                  <FlexDiv style={{ cursor: "pointer" }} onClick={handleClick}>
                    <UserLogo alt="" src={storedUserImage || UserAvatar} />
                    <NavArrow
                      alt=""
                      src={NavArrowImg}
                      style={{
                        transform: open && "rotate(180deg)",
                      }}
                    />
                  </FlexDiv>
                  <Btn
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setMobileMenu(!mobileMenu);
                    }}
                  >
                    <MobileNavMenu alt="" src={MobileMenu} />
                  </Btn>
                </FlexDiv>
              </UpgradeOuterDiv>
            </>
          )}
        </NavDivTwo>
        <ProfileDropDown
          anchorEl={anchorEl}
          open={open}
          handleClose={handleClose}
          userImage={storedUserImage || UserAvatar}
          userName={userName}
          showResultAccess={hasResultAccess}
        />
      </NavDiv>
      {!isLaptop && (
        <Collapse in={moreMenu} timeout="auto" unmountOnExit>
          <MoreMenu />
        </Collapse>
      )}
      {!isLaptop && (
        <Collapse in={megaMenu} timeout="auto" unmountOnExit>
          <MegaMenuDiv>
            <MegaMenu selectedText={selectedText} />
          </MegaMenuDiv>
        </Collapse>
      )}
      {isLaptop && (
        <Collapse in={mobileMenu} timeout="auto" unmountOnExit>
          <MobileNav />
        </Collapse>
      )}
      <Dialog open={showBookClassModal} onClose={() => setShowBookClassModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 900, color: "#1f1540" }}>Book Your 1-on-1 Class</DialogTitle>
        <DialogContent>
          <Typography sx={{ color: "#473c64", mb: 1.2 }}>
            You are about to use your included 1-on-1 class credit.
          </Typography>
          <Typography sx={{ color: "#473c64", mb: 1.2 }}>
            Please use the same email address that you use for your SwiftUni account while booking.
          </Typography>
          <Alert severity="warning" sx={{ borderRadius: "12px" }}>
            Once you continue to Calendly, this class credit will be marked as used and cannot be booked again.
          </Alert>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.4 }}>
          <Button onClick={() => setShowBookClassModal(false)} sx={{ textTransform: "none", fontWeight: 800 }}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmBookOneOnOne}
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: 900,
              borderRadius: "999px",
              background: "linear-gradient(135deg, #00a86b 0%, #0d8f76 100%)",
            }}
          >
            Continue to Booking
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Navbar;
